import { IMenuItem } from '../WorkspaceMenu';
import ModernGuestList from '../routes/ModernGuestList';
import EventSchedule from '../widgets/EventSchedule/EventSchedule';
import WebsitePreview from '../widgets/WebsitePreview';
import { appConfiguration as generalAppConfig } from '../configuration/general_default';
import { appConfiguration as weddingAppConfig } from '../configuration/wedding_default';
import { IDashboardComponent } from '../WorkspaceGrid';
import { EventCountdown } from '../widgets/EventCountdown';
import { EventType } from '@graphql/generated';

export interface IWorkspaceTile {
  componentId: string;
  allowScroll?: boolean;
  route?: string;
  link?: string;
}
export interface IAppConfig extends IMenuItem {}

const getAppTileComponent = (appId?: string) => {
  switch (appId) {
    case 'guest_list':
      return ModernGuestList;
    case 'event_schedule':
      return EventSchedule;
    case 'website':
      return WebsitePreview;
    case 'event_countdown':
      return EventCountdown;
    default:
      return;
  }
};

const getDefaultConfigByEventType = (eventType?: string) => {
  switch (eventType) {
    case 'wedding':
      return weddingAppConfig; // Replace with wedding specific configuration if available
    case 'corporate':
      return generalAppConfig;
    default:
      return generalAppConfig; // Default to general configuration
  }
};
export const EVENT_HANDLE_PLACEHOLDER = '${eventHandle}';

const formatLink = (link?: string, eventHandle?: string) => {
  if (!link || !eventHandle) {
    return undefined;
  }

  if (link.startsWith('/')) {
    // Assume link is a relative path that starts after .com/ that does NOT the event handle
    return `/${eventHandle}${link}`;
  } else if (link.startsWith(EVENT_HANDLE_PLACEHOLDER)) {
    // Assume link is a relative path that starts after the event handle
    return link.replace(EVENT_HANDLE_PLACEHOLDER, `/${eventHandle}`);
  }
  // Assume external link
  return link;
};

const formatRoute = (route?: string, eventHandle?: string) => {
  // Prepend event handle for internal routes
  return route && eventHandle ? `/${eventHandle}${route}` : undefined;
};
/*
Calculates the width of the parent container and updates it on resize 
to enable child to have responsive behavior
not tied to browser window width
*/
export const useEventSubTypeConfig = (eventType: EventType, eventHandle: string, eventCategory?: string, eventCategorySubType?: string, eventId?: string) => {
  // Example initialization for navigation and tiles
  const appConfig = getDefaultConfigByEventType(eventType); // Replace with actual logic as needed
  const navigation: IAppConfig[] = appConfig.apps.map(
    item =>
      ({
        ...item,
        route: formatRoute(item.route, eventHandle),
        link: formatLink(item.link, eventHandle),
      } as IAppConfig),
  );

  const tiles: IDashboardComponent[] = appConfig.tiles.map(item => ({
    instanceId: item.componentId,
    component: getAppTileComponent(item.componentId),
    colSpan: 1,
    allowScroll: item.allowScroll,
    route: formatRoute(item.route, eventHandle),
    link: formatLink(item.link, eventHandle),
  }));

  return { navigation, tiles };
};
